import {Component, OnInit} from '@angular/core';
import {TableComponent} from '@shared/components/table/table.component';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {
  connectionpointMeteringpointTable
} from '@shared/table-configs/connectionpoint/connectionpoint-meteringpoint.table';
import {HeaderService} from '@app/core/services/header.service';
import {PlusSquare} from 'lucide-angular';
import { AuthRoles, ConnectionPointMeteringPointDto, MeteringPointService } from '@app/api/dmc';
import {ConnectionPointDto, ConnectionPointService} from '@app/api/nts';
import { hasRole } from '@app/core/guards/has-role.guard';

@Component({
  selector: 'app-connectionpoint-meteringpoint-overview',
  imports: [
    TableComponent
  ],
  templateUrl: './connectionpoint-meteringpoint-overview.component.html',
  styleUrl: './connectionpoint-meteringpoint-overview.component.css'
})
export class ConnectionpointMeteringpointOverviewComponent implements OnInit {
  public tableData: ConnectionPointMeteringPointDto[] = [];
  public readonly meteringPointTableConfig: TableConfig<ConnectionPointMeteringPointDto> = {
    ...connectionpointMeteringpointTable,
    refreshable: true,
    refresh: () => this.fetchMeteringPoints(),
  };
  public identification!: string;
  public connectionPointDto?: ConnectionPointDto;
  public id!: string;
  public selectedElements: ConnectionPointMeteringPointDto[] = [];
  private readonly cpWriter = hasRole([AuthRoles.ConnectionPointWriter]);

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly connectionPointService: ConnectionPointService,
    private readonly route: ActivatedRoute,
    private readonly headerService: HeaderService,
    private readonly router: Router,
  ) { }

  public ngOnInit(): void {
    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.identification = q.get('id')!;
      this.id = this.identification;

      this.headerService.setActions([
        {
          id: 'create',
          title: 'connectionPoint.meteringPoint.create',
          callback: () => this.createMeteringPoint(),
          icon: PlusSquare,
          disabled: () => !this.cpWriter
        },
      ]);

      this.fetchMeteringPoints();
    });
  }

  public fetchMeteringPoints(): void {
    if (!this.identification) return;
    this.connectionPointService.connectionPointGetGet(this.identification).subscribe(connectionPoint => {
      this.connectionPointDto = connectionPoint;
      if (this.connectionPointDto?.id) {
        this.meteringPointService.meteringPointGetByConnectionPointIdGet(this.connectionPointDto.id).subscribe(meteringPoints => {
          this.tableData = meteringPoints ?? [];
        });
      }
    });
  }

  public createMeteringPoint(): void {
    this.router.navigate(['/meteringpoint', 'create'], {
      queryParams: {
        connectionPointIdentification: this.id,
        meteringPointType: 'Consumption'
      }
    });
  }
}
